import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
interface LayoutProps {
  children: ReactNode;
  currentModule: string;
  onModuleChange: (module: string) => void;
}
export function Layout({
  children,
  currentModule,
  onModuleChange
}: LayoutProps) {
  return <div className="min-h-screen bg-gray-50 dark:bg-gray-900" data-id="element-61">
      <Sidebar currentModule={currentModule} onModuleChange={onModuleChange} data-id="element-62" />
      <Header data-id="element-63" />
      <main className="ml-64 pt-16 min-h-screen" data-id="element-64">
        <div className="p-6" data-id="element-65">{children}</div>
      </main>
    </div>;
}